// extracted by mini-css-extract-plugin
module.exports = {"root":"_30RXU","itemClickWrapper":"_2kuR4","imageZoomBtn":"_2fmK7","sizer":"_2XaJ0","imageWrapper":"_1Lke8","imageBorder":"_2JzMh","image":"_2JBTe","overlay":"_3ICuM"};